import { useState } from 'react';
import { Copy, Share2, Check } from 'lucide-react';
import { toast } from 'sonner';
import { publicTransactionUrl, copyTransactionUrl, canShareTransaction, shareTransactionUrl } from '../utils/transactionSharing';

export default function TransactionShareActions({ shareCode, compact = false }) {
  const url = publicTransactionUrl(shareCode);
  const [copied, setCopied] = useState(false);
  const [busy, setBusy] = useState(false);
  const notifyCopied = () => { setCopied(true); toast.success('Transaction link copied'); };
  const perform = async (share) => {
    setBusy(true);
    try {
      if (share) { if (await shareTransactionUrl(url) === 'copied') notifyCopied(); }
      else { await copyTransactionUrl(url); notifyCopied(); }
    } catch { toast.error('Could not copy the link. Please try again.'); }
    finally { setBusy(false); }
  };
  if (!url) return null;
  return <div className={`tt-share-actions${compact ? ' tt-share-tertiary' : ''}`}>
    <button type="button" className="tt-button tt-button-secondary" onClick={() => perform(false)} disabled={busy} data-testid="copy-share-link-btn">
      {copied ? <Check size={17} /> : <Copy size={17} />} Copy transaction link
    </button>
    {canShareTransaction(url) && <button type="button" className="tt-button tt-button-secondary" onClick={() => perform(true)} disabled={busy} data-testid="native-share-btn"><Share2 size={17} /> Share transaction</button>}
    <span role="status" className="tt-share-feedback">{copied ? 'Transaction link copied' : ''}</span>
  </div>;
}
